import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-phone-record',
  standalone: false,
  templateUrl: './phone-record.component.html',
  styleUrl: './phone-record.component.css'
})
export class PhoneRecordComponent {
  shareObject: any = {
    selectedRows: new Set(),
    lastSelectedIndex: null,
    checkList: [],
    component: '/callrecord',
    addURL: '/user/phone/record/create',
    bulkURL: '/user/phone/record/create/bulk',
    deletedURL: '/user/phone/record/deleted',
  };
  filterForm!: FormGroup;
  addForm!: FormGroup;
  constructor(
    public sharedService: SharedService,
    public translate: TranslateService,
    public router: Router,
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = {
      filter: {},
      filterAdvance: {},
      page: 1,
      limit: this.sharedService.env.pageSize[0]
    };
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
        this.shareObject.options.filter.phone = params['id'];
      }
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['phone']) {
        this.shareObject.filterPhone = params['phone'];
      }
      if (params['participant']) {
        this.shareObject.options.filter.participant = params['participant'];
      }
      if (params['group']) {
        this.shareObject.filterGroup = params['group'];
      }
    });
    // });
    this.shareObject.callTypes = [
      { id: 0, name: this.translate.instant('call_type_unknown') },
      { id: 1, name: this.translate.instant('call_type_incoming') },
      { id: 2, name: this.translate.instant('call_type_outgoing') },
      { id: 3, name: this.translate.instant('call_type_missed') },
      { id: 4, name: this.translate.instant('call_type_voicemail') },
      { id: 5, name: this.translate.instant('call_type_rejected') },
      { id: 6, name: this.translate.instant('call_type_blocked') },
      { id: 7, name: this.translate.instant('call_type_answered_externally') },
    ];
  }
  ngOnInit(): void {
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.addForm = this.fb.group({
      phone: ['0941549525'],
      duration: [50],
      type: [1],
      participant: ['0911416456'],
      callAt: [Date.now()],
      record: [''],
    });
    this.filterForm = this.fb.group({
      limit: [this.sharedService.env.pageSize[0]],
      startDate: [''],
      endDate: [''],
      phoneNumber: [''],
      keyword: [''],
      group: [''],
      duration: [''],
      type: [''],
    });
    this.sharedService.callApi('/employee_group/list', { limit: 1000 }).subscribe((res: any) => {
      this.shareObject.employeeGroups = res.data.data;
      if (this.shareObject.filterGroup) {
        this.filterForm.patchValue({
          group: this.shareObject.filterGroup
        });
      }
      if (this.shareObject.filterPhone) {
        this.filterForm.patchValue({
          phoneNumber: this.shareObject.filterPhone
        });
      }
      this.onSearch();
    });
  }
  filter(key: any, value: any) {
    if (key == 'type') {
      this.shareObject.callTypes = this.shareObject.callTypes.map((item: any) => {
        item.checked = item.id == value;
        return item;
      })
    }
    this.filterForm.patchValue({ [key]: value });
    this.shareObject.options.filter[key] = value;
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.shareObject.options.sort = { callAt: -1 };
    if (this.shareObject.audio) {
      this.shareObject.audio.pause();
      this.shareObject.audio.currentTime = 0;
      this.shareObject.audio = null;
    }
    let path = this.shareObject.data.type == 'deleted' ? `${this.shareObject.component}/list_deleted` : `${this.shareObject.component}/list`;
    this.sharedService.callApi(path, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.shareObject.items = res.data.data.map((item: any) => {
          item.typeText = this.shareObject.callTypes.find((e: any) => e.id == item.type)?.name;
          item.callAtText = new Date(item.callAt);
          return item;
        })
        //tính tổng cuộc gọi theo từng loại
        this.shareObject.callTypes.forEach((type: any) => {
          type.count = this.shareObject.items.filter((item: any) => item.type == type.id).length;
        })
        this.shareObject.pagination = res.data.pagination;
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/get`, { callId: this.shareObject.id }).subscribe({
      next: (res: any) => {
        this.shareObject.warehouse = res.data;
        this.addForm.patchValue({
          number: res.data.number,
          note: res.data.note,
          status: res.data.status,
        })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  addItem() {
    this.shareObject.isLoading = true;
    this.addForm.value.record = this.shareObject.recordBase64;
    this.sharedService.callApi(`${this.shareObject.component}/add`, this.addForm.value).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('add_success'),
            type: 'success',
          });
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  updateItem() {
    this.shareObject.isLoading = true;
    this.addForm.value.record = this.shareObject.recordBase64;
    this.sharedService.callApi(`${this.shareObject.component}/update`, { callId: this.shareObject.id, ...this.addForm.value }).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  onSubmit() {
    if (this.shareObject.data.type == 'edit') {
      this.updateItem()
    }
    else {
      this.addItem()
    }
  }
  deleteItem(ids: string[]) {
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi('/call/delete', { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getItems();
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.filterForm.reset();
    this.filterForm.patchValue({
      limit: this.sharedService.env.pageSize[0],
      startDate: '',
      endDate: '',
      group: '',
      type: '',
    })
    this.shareObject.selectedRows.clear();
    this.getItems();
  }
  softDeleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_soft_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  restoreItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_restore'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/restore_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('restore_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  onSearch() {
    // const now = new Date();
    // const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    // lastMonth.setHours(0, 0, 0, 0);
    this.shareObject.options.limit = this.filterForm.value.limit ?? this.sharedService.env.pageSize[0];
    if (this.filterForm.value.startDate && this.filterForm.value.startDate != '') {
      this.shareObject.options.filter.callAt = { $gte: new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0) };
    }
    if (this.filterForm.value.endDate && this.filterForm.value.endDate != '') {
      this.shareObject.options.filter.callAt = { ...this.shareObject.options.filter.callAt, $lte: new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999) };
    }
    // this.shareObject.options.filter.callAt = { $gte: new Date(lastMonth).getTime(), $lte: new Date(new Date().setHours(23, 59, 59, 999)).getTime() };
    // this.shareObject.options.filter.callAt.$gte = this.filterForm.value.startDate && new Date(new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0)).getTime();
    // this.shareObject.options.filter.callAt.$lte = this.filterForm.value.endDate && new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999)).getTime();
    this.shareObject.options.filter.duration = this.filterForm.value['duration'] ? { $gt: 0 } : undefined;
    this.shareObject.options.filter.type = this.filterForm.value['type'] ?? undefined;
    this.shareObject.options.filter.phoneNumber = this.filterForm.value['phoneNumber'] ?? undefined;
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ?? undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.limit = this.filterForm.value['limit'] ?? this.sharedService.env.pageSize[0];
    if (this.filterForm.value['type'] && this.filterForm.value['type'] != '') {
      this.shareObject.typeText = this.shareObject.callTypes.find((e: any) => e.id == this.filterForm.value['type'])?.name;
    }

    this.shareObject.options.filter.group = this.filterForm.value['group'] ?? undefined;
    if (this.shareObject.options.filter.group) {
      this.shareObject.groupText = this.shareObject.employeeGroups.find((e: any) => e.id == this.shareObject.options.filter.group)?.name;
    }
    this.getItems();
  }
  fileChange(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.shareObject.recordBase64 = reader.result as string;
    };
  }
  stopAudio(item: any) {
    if (this.shareObject.audio) {
      this.shareObject.audio.pause();
      this.shareObject.audio.currentTime = 0;
      this.shareObject.audio = null;
    }
    item.play = false;
  }
  pauseAudio(item: any) {
    if (this.shareObject.audio) {
      this.shareObject.audio.pause();
      item.play = false;
    }
  }
  resumeAudio(item: any) {
    if (this.shareObject.audio) {
      this.shareObject.audio.play();
      item.play = true;
    }
  }
  playAudio(item: any) {
    console.log(item);
    this.shareObject.callRecord = item;
    if (this.shareObject.audio) {
      // destroy the audio object
      this.shareObject.audio.pause();
      this.shareObject.audio.currentTime = 0;
      this.shareObject.audio = null;
    }
    const audio = new Audio(`${this.sharedService.env.apiUrl}/callrecord/record/${item.id}.m4a`);
    console.log(`audio`, audio);
    audio.play();
    audio.onended = () => {
      this.shareObject.items = this.shareObject.items.map((e: any) => {
        e.play = false;
        return e;
      });
    }
    audio.onerror = () => {
      this.sharedService.toast({
        title: this.translate.instant('error'),
        message: this.translate.instant('audio_play_error'),
        type: 'danger',
      });
      this.shareObject.items = this.shareObject.items.map((e: any) => {
        e.play = false;
        return e;
      });
      this.shareObject.audio = null;
    }
    audio.onplay = (e) => {
      this.shareObject.items = this.shareObject.items.map((e: any) => {
        e.play = false;
        return e;
      });
      item.play = true;
    }
    audio.onpause = () => {
      this.shareObject.items = this.shareObject.items.map((e: any) => {
        e.play = false;
        return e;
      });
    }
    // On time update, set the current time of the audio to the current time of the audio element
    audio.ontimeupdate = () => {
      // this.shareObject.audio.currentTime = audio.currentTime;
    }
    this.shareObject.audio = audio;
  }
  onAudioSeek(event: any) {
    if (this.shareObject.audio) {
      this.shareObject.audio.currentTime = event.target.value;
      // play audio if not playing
      if (this.shareObject.audio.paused) {
        this.shareObject.audio.play();
      }
    }
  }
  downloadAudio(item: any) {
    (window as any).open(`${this.sharedService.env.apiUrl}/callrecord/record/${item.id}.m4a`, '_blank');
  }
  formatTime(seconds: number): string {
    if (!seconds && seconds !== 0) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' + secs : secs}`;
  }
  isAllSelected(data: any[] = []): boolean {
    return this.shareObject.selectedRows.size === data.length;
  }
  toggleSelectAll(event: Event, data: any[]) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      data.forEach((_, index) => this.shareObject.selectedRows.add(index));
    } else {
      this.shareObject.selectedRows.clear();
    }
  }
  selectRow(event: MouseEvent, index: number) {
    //check nếu index đã có trong selectedRows thì bỏ chọn
    if (this.shareObject.selectedRows.has(index)) {
      this.toggleRowSelection(index);
      return;
    }
    if (event.ctrlKey || event.metaKey) {
      // Ctrl/Cmd click: toggle selection
      this.toggleRowSelection(index);
    } else if (event.shiftKey && this.shareObject.lastSelectedIndex !== null) {
      // Shift click: select range
      this.selectRange(this.shareObject.lastSelectedIndex, index);
    } else {
      // Regular click: single selection
      this.selectSingleRow(index);
    }
    this.shareObject.lastSelectedIndex = index;
  }
  toggleRowSelection(index: number) {
    if (this.shareObject.selectedRows.has(index)) {
      this.shareObject.selectedRows.delete(index);
    } else {
      this.shareObject.selectedRows.add(index);
    }
  }
  selectSingleRow(index: number) {
    this.shareObject.selectedRows.clear();
    this.shareObject.selectedRows.add(index);
  }
  selectRange(start: number, end: number) {
    this.shareObject.selectedRows.clear();
    const [from, to] = [Math.min(start, end), Math.max(start, end)];
    for (let i = from; i <= to; i++) {
      this.shareObject.selectedRows.add(i);
    }
  }
  handleIndextoId(idexes: any) {
    const selectedIds = Array.from(idexes).map((index: any) => this.shareObject.items[index].id);
    return selectedIds;
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }

  getUsers() {
    if (this.shareObject.employees && this.shareObject.employees.length > 0) {
      console.log(`this.shareObject.employees`, this.shareObject.employees);
      this.sharedService.modalControl('#export_file');
      return;
    };
    this.sharedService.callApi('/users/list', { limit: 1000 }).subscribe((res: any) => {
      if (res.success) {
        console.log(res.data);
        this.shareObject.employees = res.data.data;
        this.sharedService.modalControl('#export_file');
      }
    });
  }

  checked(id: any) {
    console.log(id);
    if (this.shareObject?.checkList?.includes(id)) {
      this.shareObject.checkList = this.shareObject.checkList.filter((item: any) => item != id);
    } else {
      this.shareObject?.checkList?.push(id);
    }
    console.log(this.shareObject.checkList);
    this.shareObject.isCheckAll = this.shareObject?.checkList?.length == this.shareObject?.employees?.length;
    this.shareObject.employees = this.shareObject.employees.map((item: any) => {
      item.checked = this.shareObject?.checkList?.includes(item.id);
      return item;
    });
    this.cdRef.detectChanges();
  }
  checkAll() {
    this.shareObject.isCheckAll = !this.shareObject.isCheckAll;
    this.shareObject.employees = this.shareObject.employees.map((item: any) => {
      item.checked = this.shareObject.isCheckAll;
      return item;
    });
    if (this.shareObject.isCheckAll) {
      this.shareObject.checkList = this.shareObject.employees.map((item: any) => item.id);
    } else {
      this.shareObject.checkList = [];
    }
    this.cdRef.detectChanges();
  }
  exportFile() {
    this.sharedService.callApi(`${this.shareObject.component}/export_file`, { employees: this.shareObject.checkList }).subscribe((res: any) => {
      if (res.success) {
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('export_success'),
          type: 'success',
        });
        this.sharedService.modalControl('#export_file');
        this.shareObject.checkList = [];
        this.shareObject.employees = [];
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: res.message,
          type: 'danger',
        });
      }
    });
  }
}

